import React from 'react';
import PropTypes from 'prop-types';
import { SectionHeading } from 'web-ui-components/lib/molecules/text';
import { contentPropTypes } from '../AddNewPayeeLandingPage/index.content';
import AddressForm from '../../../sharedComponents/AddressForm';
import { addPayeeFormPropTypes, validationPropsProtoTypes } from '../../states/addPayee/propTypes';
import { PayeeAddressLine1, PayeeCity, PayeeCountry, ChapsReferenceInput } from './withValidationComponents';
import { addPayeeFormLengths } from '../../../config';

const ChapsDetails = ({ content, updateAddPayeeForm, addPayeeForm, validationProps }) => {
	const { chapsReferenceLabel, chapsReferenceDescription, payeeAddressTitle } = content;
	const { chapsReference, payeeAddressLine1, payeeAddressLine2, payeeCity, payeePostalCode, payeeCountry } =
		addPayeeForm;
	return (
		<span>
			<ChapsReferenceInput
				id="chapsReference"
				label={chapsReferenceLabel}
				type="textarea"
				description={chapsReferenceDescription}
				chapsReference={chapsReference}
				value={chapsReference}
				{...validationProps}
				onChange={({ value }) => updateAddPayeeForm({ target: { value, id: 'chapsReference' } })}
				maxLength={addPayeeFormLengths.chapsReference}
				maximumCharacters={addPayeeFormLengths.chapsReference}
			/>
			<SectionHeading heading2={payeeAddressTitle}></SectionHeading>
			<AddressForm
				validationProps={validationProps}
				addressLine1={{
					id: 'payeeAddressLine1',
					value: payeeAddressLine1,
					payeeAddressLine1,
					component: PayeeAddressLine1,
				}}
				addressLine2={{ id: 'payeeAddressLine2', value: payeeAddressLine2, payeeAddressLine2 }}
				city={{ id: 'payeeCity', value: payeeCity, payeeCity, component: PayeeCity }}
				postalCode={{
					id: 'payeePostalCode',
					value: payeePostalCode,
					payeePostalCode,
				}}
				country={{ id: 'payeeCountry', value: payeeCountry, payeeCountry, component: PayeeCountry }}
				content={content}
			/>
		</span>
	);
};

ChapsDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	updateAddPayeeForm: PropTypes.func.isRequired,
	addPayeeForm: PropTypes.shape(addPayeeFormPropTypes).isRequired,
	validationProps: PropTypes.shape(validationPropsProtoTypes).isRequired,
};

export default ChapsDetails;
